import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../../../lib/utils';
import { SpecraIconButton } from '../ensigns/icon-button';
import { SpecraStatusDot } from '../ensigns/status-dot';
import { SpecraText } from '../ensigns/typography';
/** Transient feedback content compatible with any host toast manager. */ export function SpecraToastMessage({ action, className, description, onDismiss, title, tone = 'neutral', ...props }) {
    return /*#__PURE__*/ _jsxs("div", {
        className: cn('flex w-80 max-w-full items-start gap-3 rounded-lg border border-border bg-card p-3 shadow-[var(--shadow-md)]', className),
        role: tone === 'danger' ? 'alert' : 'status',
        ...props,
        children: [
            /*#__PURE__*/ _jsx(SpecraStatusDot, {
                className: "mt-1.5",
                tone: tone
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "min-w-0 flex-1",
                children: [
                    /*#__PURE__*/ _jsx(SpecraText, {
                        className: "block font-medium",
                        size: "caption",
                        children: title
                    }),
                    description ? /*#__PURE__*/ _jsx(SpecraText, {
                        className: "mt-0.5 block",
                        size: "caption",
                        tone: "muted",
                        children: description
                    }) : null,
                    action ? /*#__PURE__*/ _jsx("div", {
                        className: "mt-2",
                        children: action
                    }) : null
                ]
            }),
            onDismiss ? /*#__PURE__*/ _jsx(SpecraIconButton, {
                label: "Dismiss notification",
                onClick: onDismiss,
                size: "sm",
                variant: "ghost",
                children: "×"
            }) : null
        ]
    });
}
